import { WSButton } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { NotificationTemplate } from "../index";
import { useGoToDashboardPayerRequirementDetails } from "../../../routes/RouteRequirementDetails/RoutePayerRequirementDetails";

export type SignatureCollaboratorContext = {
  payer: {
    payerId: string;
    payerName: string;
    logoFileId: string;
  };
  requirement: {
    requirementId: string;
    name: string;
  };
};

const GROUP_THRESHOLD = 2;

export const SignatureCollaborator: NotificationTemplate<SignatureCollaboratorContext> =
  {
    renderTitle: props =>
      props.group.length >= GROUP_THRESHOLD
        ? "Multiple e-signatures required"
        : "E-signature required",
    renderBody: props => {
      const clientName = props.context.payer.payerName;
      const documentName = props.context.requirement.name;

      if (props.group.length >= GROUP_THRESHOLD) {
        return "Your clients require that you sign documents to complete the onboarding process";
      }

      return (
        <>
          Company <b>{clientName}</b> requires that you sign{" "}
          <b>{documentName}</b> to complete the onboarding process
        </>
      );
    },
    Footer: props => {
      const history = useHistory();
      const goToPayerRequirementDetails =
        useGoToDashboardPayerRequirementDetails();
      const documentName = props.context.requirement.name;

      if (props.group.length >= GROUP_THRESHOLD) {
        return (
          <WSButton.Link
            size="S"
            rightIcon="chevron-right"
            onClick={() => {
              history.push("/member/dashboard/collaborators-e-signatures");
            }}
          >
            Sign documents
          </WSButton.Link>
        );
      } else {
        return (
          <WSButton.Link
            size="S"
            rightIcon="chevron-right"
            onAsyncClick={async () => {
              goToPayerRequirementDetails({
                requirementId: props.context.requirement.requirementId,
                payerId: props.context.payer.payerId
              });
            }}
          >
            Sign <b>{documentName}</b>
          </WSButton.Link>
        );
      }
    }
  };
